import { themeVars } from '@synoptic/ui-kit/theme/vars.ts';
import { style } from '@vanilla-extract/css';

export const streamPriceTag = style({
  outline: 'none',
  color: themeVars.container.foreground.primary,

  selectors: {
    '&[data-shown]': {
      outline: `1px solid ${themeVars.container.border.default}`,
    },
  },
});
